import axios from '../axios';
import { LOGIN_BRANCH_API } from '../ApiUrl';

/**
 * POST /LoginBranch — same call shape as Kitchen `loginAPI`.
 * Interceptor wraps 2xx as `{ hasError: false, data: { ...body, fetchApiTime } }`.
 * Auth failures are often HTTP 200 with `success: false` (handled in BranchLoginProvider).
 */
export const loginBranchAPI = async (payload) => {
  try {
    const response = await axios.post(LOGIN_BRANCH_API, payload);
    return response;
  } catch (error) {
    console.log('loginBranchAPI catch block', error);
    return { hasError: true, error };
  }
};
